import React, { useEffect } from "react";
import { usePageTitle } from "@/store/use-page-title-store";
import { useTranslation } from "react-i18next";
import { BackButton } from "@/components/ui/back-button";
import {
  CartSection,
  FavoritesSection,
  RecentlyViewedSection,
  DiscoverMoreSection,
} from "@/features/cart/sections";
import { useCart } from "@/features/cart/hooks/use-cart";

export const CartPage: React.FC = () => {
  const { t } = useTranslation();
  const { setPageTitle, clearPageTitle } = usePageTitle();

  useEffect(() => {
    setPageTitle("cart.title", "cart.subtitle");
    return () => clearPageTitle();
  }, [setPageTitle, clearPageTitle]);

  const { totalItems } = useCart();

  return (
    <div className="h-full overflow-y-auto bg-bg-primary dark:bg-bg-primary">
      {/* Header Section - Consistent with other pages */}
      <div className="w-full border-b border-border-secondary dark:border-border-secondary">
        <div className="pt-4 md:pt-6 pb-4 md:pb-6 max-w-screen-2xl px-4 md:px-0 mx-auto">
          <div className="flex flex-col gap-2 md:gap-4">
            {/* Title & Description */}
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <BackButton />
                <h1 className="text-lg md:text-xl lg:text-2xl font-semibold text-text-primary dark:text-text-primary leading-6 md:leading-7 lg:leading-8">
                  {t("cart.title")}
                </h1>
                <span className="text-base md:text-lg font-medium text-gray-500 dark:text-gray-400">
                  ({totalItems}{" "}
                  {totalItems === 1 ? t("cart.product") : t("cart.products")})
                </span>
              </div>
              <p className="ml-8 text-xs md:text-sm lg:text-base text-text-tertiary dark:text-text-tertiary leading-4 md:leading-5 lg:leading-6">
                {t("cart.subtitle")}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content - Consistent padding */}
      <div className="px-4 md:px-16 py-4 md:py-6">
        <div className="flex flex-col gap-6 md:gap-8 max-w-screen-2xl mx-auto w-full">
          <CartSection />
          <FavoritesSection />
          <RecentlyViewedSection />
          <DiscoverMoreSection />
        </div>
      </div>
    </div>
  );
};
